import VispTaskService from './visp-task-service.vue';

VispTaskService.install = function(Vue) {
    Vue.component(VispTaskService.name, VispTaskService);
};

export { VispTaskService };